import React from "react";
import PropTypes from "prop-types";
import { connectToggleRefinement } from "react-instantsearch-dom";
import Toggle from "react-toggle";

import "components/base/Toggle/index.css";
import { cn } from "utils";

const FilterToggle = ({ label, currentRefinement, refine, className }) => {
  const handleChange = ({ target: { checked } }) => {
    refine(checked);
  };

  return (
    <div className={cn("flex items-center justify-between gap-2", className)}>
      <span className="font-inter text-sm font-medium leading-normal text-[#334155]">
        {label}
      </span>
      <Toggle
        checked={currentRefinement}
        onChange={handleChange}
        icons={false}
        className="customToggle"
      />
    </div>
  );
};

FilterToggle.propTypes = {
  label: PropTypes.string.isRequired,
  currentRefinement: PropTypes.bool,
  refine: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const ConnectedFilterToggle = connectToggleRefinement(FilterToggle);

const FilterToggleRefinement = ({
  attribute,
  label,
  value,
  defaultRefinement,
  className,
}) => {
  return (
    <ConnectedFilterToggle
      attribute={attribute}
      label={label}
      value={value}
      defaultRefinement={defaultRefinement}
      className={className}
    />
  );
};

FilterToggleRefinement.propTypes = {
  attribute: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  defaultRefinement: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
};

export default FilterToggleRefinement;
